export default "__VITE_ASSET__Dmjoy5B5__"